import { MessageSquare, History, Settings, SquarePen, Film } from 'lucide-react';

export const USER_NAV_ITEMS = [
  { id: 'chat',          label: 'Chat',          icon: MessageSquare, path: '/user',                hasChildren: true },
  { id: 'history',       label: 'Chat History',  icon: SquarePen,     path: '/user/history',        hasChildren: true },
  { id: 'media-library', label: 'Media Library', icon: Film,          path: '/user/media-library' },
  { id: 'settings',      label: 'Settings',      icon: Settings,      path: '/user/settings' },
];
